import GoogleMapReact from 'google-map-react'

export default class Map extends Component {
    constructor(props) {
        super(props)
        this.getGoogleMapApi = this.getGoogleMapApi.bind(this)
        this.state = {
            map: null,
        }
    }

    getGoogleMapApi({ map }) {
        this.setState({
            map,
        })
    }

    renderChildrenWithMapProps() {
        const {
            children,
            opngo,
            geoLocation: { x: lat, y: lng },
        } = this.props
        const childrenWithProps = React.Children.map(children, child =>
            React.cloneElement(child, {
                map: this.state.map,
                opngo,
                lat,
                lng,
            })
        )
        return childrenWithProps
    }

    render() {
        const {
            geoLocation: { x: lat, y: lng },
        } = this.props

        return (
            <GoogleMapReact
                onGoogleApiLoaded={this.getGoogleMapApi}
                yesIWantToUseGoogleMapApiInternals
                center={{ lat, lng }}
                options={{
                    minZoom: 15,
                    scrollwheel: false,
                    draggable: false,
                    zoomControl: false,
                    disableDoubleClickZoom: true,
                    fullscreenControl: true,
                }}
                zoom={15}>
                {this.renderChildrenWithMapProps()}
            </GoogleMapReact>
        )
    }
}
